"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    createBasketRequest: ()=>createBasketRequest
});
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const fetchWithTimeout_js_namespaceObject = require("../utils/fetchWithTimeout.js");
var fetchWithTimeout_js_default = /*#__PURE__*/ __webpack_require__.n(fetchWithTimeout_js_namespaceObject);
const CREATE_BASKET_MUTATION = `
mutation CreateBasket($basketPayload: CreateBasketPayload) {
  createBasket(basketPayload: $basketPayload) {
    checkoutUrl
  }
}
`;
const createBasketRequest = (options)=>{
    const { appc, hotelOptions, cguid, rguid } = options;
    const { itemKey, itemType = 'STAY', priceKey, nightlyRateIncludingTaxesAndFees, minCurrencyCode = 'USD', minCurrencyCodeSymbol = '$' } = hotelOptions;
    const requestBody = {
        operationName: 'CreateBasket',
        query: CREATE_BASKET_MUTATION,
        variables: {
            basketPayload: {
                item: {
                    itemKey,
                    itemType,
                    priceKey
                },
                meta: {
                    appc,
                    cguid,
                    rguid,
                    plf: 'PCLN',
                    gpcd: 'PCLN',
                    pointOfSale: {
                        countryCode: 'US',
                        languageCode: 'ENG',
                        currencyCode: 'USD'
                    },
                    authToken: null
                },
                price: {
                    currencyCode: minCurrencyCode,
                    currencySymbol: minCurrencyCodeSymbol,
                    payment: {
                        total: Number(nightlyRateIncludingTaxesAndFees)
                    }
                }
            }
        }
    };
    fetchWithTimeout_js_default()("/pws/v0/pcln-graph/?gqlOp=CreateBasket", {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }, 10000).then((res)=>res.json()).then((createBasketResponse)=>{
        if (createBasketResponse?.data?.createBasket?.checkoutUrl) {
            const ref = window.open(createBasketResponse.data.createBasket.checkoutUrl, '_blank');
            if (!ref) alert('Please allow pop-ups in your browser. Thanks!');
        } else throw new Error('no checkout url');
    }).catch((err)=>{
        alert('Redirect failed. Please retry or use the detail link. Thanks!');
        analytics_js_default().logError({
            message: 'Error creating basket',
            error: err.message
        });
    });
};
exports.createBasketRequest = __webpack_exports__.createBasketRequest;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "createBasketRequest"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
